import React, { useState, useEffect } from "react";
import Sidebar from "../components/sidebar";
import Card from "react-bootstrap/Card";
import DataTable from "react-data-table-component";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import Cargando from "../components/cargando";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import SinPermisos from "./../components/sinpermisos";
import Nav from "react-bootstrap/Nav";

const url = "https://api.mrcirp.com/public/pixels";
const urlupdate = "https://api.mrcirp.com/public/pixelsupdate";
const urldelete = "https://api.mrcirp.com/public/pixelsdelete";
const urlUsuarios = "https://api.mrcirp.com/public/usuarios";
const urlCampanasAudiencia = "https://api.mrcirp.com/public/campanas-audiencia";

const Pixels = () => {
  //////////////Datos de Usuario Logueado///////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [users, setUsers] = useState([]);
  const [campanas, setCampanas] = useState([]); //////////////////////////////////////////////////////////////////////////////////////// Estado para almacenar las campañas

  useEffect(() => {
    const loginUserJSON = window.localStorage.getItem("loginUser");
    if (loginUserJSON) {
      const user = JSON.parse(loginUserJSON);
      setUsers(user);
    }
  }, []);

  useEffect(() => {
    if (users.id) {
      peticionGetCampanas(users.id);
    }
  }, [users.id]);

  const peticionGetCampanas = async (userId) => {
    try {
      // Igual que Mislanding: traer campañas de video + audiencia y unirlas
      const [responseVideo, responseAudiencia] = await Promise.all([
        axios.get(urlUsuarios),
        axios.get(urlCampanasAudiencia),
      ]);

      const filteredVideo = (responseVideo.data || []).filter(
        (item) => item.creador === userId
      );
      const filteredAudiencia = (responseAudiencia.data || []).filter(
        (item) => item.admin_id === userId
      );

      const videoCampaigns = filteredVideo.map((item) => ({
        id_campana: `video-${item.id ?? item.usuario ?? Math.random().toString(36).slice(2)}`,
        campana: item.nombrecampana || item.nombre_campana || item.usuario || "Sin nombre",
        tipo: "video",
      }));

      const audienciaCampaigns = filteredAudiencia.map((item) => ({
        id_campana: `audiencia-${item.id ?? item.enlace_campana ?? Math.random().toString(36).slice(2)}`,
        campana: item.nombre_campana || item.nombrecampana || item.enlace_campana || "Sin nombre",
        tipo: "audiencia",
      }));

      setCampanas([...videoCampaigns, ...audienciaCampaigns]);
    } catch (error) {
      console.error("Error al obtener las campañas:", error);
    }
  };

  console.log(campanas);

  //////////////Iniciando Status data////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [data, setData] = useState([]); // Inicializar como array

  const [datosSeleccionados, setDatosSeleccionados] = useState({
    id: "",
    pixels: "",
    red: "",
    campana: "", // Agregar campo para campaña
    id_campana: "", // Agregar campo para ID de campaña
  });

  const [nuevoPixel, setNuevoPixel] = useState({
    pixel: "",
    red: "",
    campana: "", // Agregar campo para campaña
    id_campana: "", // Agregar campo para ID de campaña
  });

  /////////////////Datatable///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const paginationComponentOptions = {
    rowsPerPageText: "Filas por página",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  const [pending, setPending] = useState(true);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setPending(false);
    }, 100);
    return () => clearTimeout(timeout);
  }, []);

  const columns = [
    {
      name: "Accion",
      button: true,
      cell: (row) => (
        <Nav style={{ display: 'flex', justifyContent: 'space-between'}}>
          <button
            onClick={() => {
              setDatosSeleccionados(row);
              abrirModalEditaruser();
            }}
            className="custom-btn"
            style={{ marginRight: "25px" }}
          >
            <FaIcons.FaRegEdit />
          </button>
          <button
          onClick={() => {
            setDatosSeleccionados(row);
            abrirModalEliminar();
          }}
          className="custom-btn"
          style={{ marginRight: "5px" }}
        >
          <FaIcons.FaRegTrashAlt />
        </button>
        </Nav>
      ),
    },
    {
      name: "Id",
      selector: (row) => row.id,
      defaultSortAsc: true,
      sortable: true,
    },
    {
      name: "Pixel",
      selector: (row) => row.pixels,
    },
    {
      name: "Campaña",
      selector: (row) => row.campana,
    },
    {
      name: "Red",
      selector: (row) => row.red,
    },
  ];

  /////////////Buscar datos////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [buscar, setBuscar] = useState("");
  const [filtrobuscar, setFiltroBuscar] = useState([]);

  useEffect(() => {
    const result = data.filter((resultdata) => {
      if (
        resultdata.pixels.toLowerCase().match(buscar.toLowerCase()) ||
        resultdata.red.toLowerCase().match(buscar.toLowerCase())
      ) {
        return resultdata;
      }
    });
    setFiltroBuscar(result);
  }, [buscar, data]);

  /////////////////////Insertar Datos API/////////////////////////////////////////////////////////////////////////////////////////////////

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "id_campana") {
      const selectedCampana = campanas.find(campana => campana.id_campana === value);
      setDatosSeleccionados((prevState) => ({
        ...prevState,
        id_campana: value,
        campana: selectedCampana ? selectedCampana.campana : ""
      }));
    } else {
      setDatosSeleccionados((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const handleNuevoPixelChange = (e) => {
    const { name, value } = e.target;
    if (name === "id_campana") {
      const selectedCampana = campanas.find(campana => campana.id_campana === value);
      setNuevoPixel((prevState) => ({
        ...prevState,
        id_campana: value,
        campana: selectedCampana ? selectedCampana.campana : ""
      }));
    } else {
      setNuevoPixel((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const [Error, setError] = useState(false);

  //////////////INSERTAR///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const [modalAgregar, setModalAgregar] = useState(false);
  const abrirModalAgregar = () => {
    setModalAgregar(true);
  };

  const peticionPost = async () => {
    const nuevoPixelConUsuario = {
      ...nuevoPixel,
      userId: users.id, // Agregar el ID del usuario registrado
    };
    console.log(nuevoPixelConUsuario);
    await axios.post(url, nuevoPixelConUsuario).then(res => {
      peticionGet();
      setError(false);
      setModalAgregar(false);
    })
      .catch((err) => {
        setError(true);
      })
  }

  //////////////Editar datos///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  const [modalEditaruser, setModalEditaruser] = useState(false);
  const abrirModalEditaruser = () => {
    setModalEditaruser(true);
  };

  const peticionPutuser = async () => {
    await axios
      .put(urlupdate  + "/" + datosSeleccionados.id, datosSeleccionados)
      .then((response) => {
        console.log(response.data);
        peticionGet();
        setError(false);
        setModalEditaruser(false);
      })
      .catch((err) => {
        setError(true);
        setModalEditaruser(false);
      });
  };

    //////////////Eliminar///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const [ModalEliminar, setModalEliminar] = useState(false);
  const abrirModalEliminar = () => {
    setModalEliminar(true);
  };

  const peticionEliminar = async () => {
    try {
      await axios.delete(`${urldelete}/${datosSeleccionados.id}`);
      peticionGet();
      setError(false);
      setModalEliminar(false);
    } catch (err) {
      setError(true);
      setModalEliminar(false);
    }
  };

   /////////////Mostrar datos////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  const peticionGet = async () => {
    console.log(users);
    await axios.get(url + "/" + users.id).then((response) => {
      setData(response.data); // Asegúrate de que la respuesta sea un array
      setFiltroBuscar(response.data);
    });
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (users.id) {
      peticionGet();
    }
  }, [users.id]);

  ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  if (users.rol !== undefined) {
    if (users.rol === "cliente") {
      return (
        <div>
          <div className="Categorias">
            <Sidebar>
              <Card>
                <Card.Header className="bg-dark text-white" as="h3">
                  <div className="row">
                    <div className="col-md-12">Pixels</div>
                  </div>
                </Card.Header>
                <Card.Body>
                  <Card.Title> Pixels registrados</Card.Title>
                  {Error && (
                    <div className="alert alert-danger">
                      {
                        <strong>
                          Error: El nombre ya existe! intente con otro nombre.
                        </strong>
                      }
                    </div>
                  )}
                  <p> Solo puede haber un Pixels registrado por campaña, en que caso de que existan 2 pixels asignado a la misma campaña el sistema tomara en cuenta el primero.</p>
                  <button
                    className="btn btn-info"
                    onClick={abrirModalAgregar}
                  >
                    Añadir Pixels
                  </button>
                  <DataTable
                    columns={columns}
                    data={filtrobuscar}
                    noDataComponent="No hay pixels"
                    progressPending={pending}
                    progressComponent={<Cargando />}
                    pagination
                    paginationComponentOptions={paginationComponentOptions}
                    subHeader
                    subHeaderComponent={
                      <input
                        type="text"
                        placeholder="Buscar Pixel"
                        className="w-25 form-control"
                        value={buscar}
                        onChange={(e) => setBuscar(e.target.value)}
                      />
                    }
                  />

                  <Modal isOpen={ModalEliminar}>
                    <ModalHeader>
                      <div>
                        <h4>Eliminar Pixel </h4>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <input
                        className="form-control"
                        readOnly
                        type="hidden"
                        name="id"
                        value={datosSeleccionados.id}
                        onChange={handleChange}
                      />
                      <div className="form-group">
                        <h5>
                          ¿Desea eliminar el pixel #{datosSeleccionados.id}?{" "}
                        </h5>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalEliminar(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-danger"
                        onClick={() => peticionEliminar()}
                      >
                        Eliminar
                      </button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={modalEditaruser}>
                    <ModalHeader>
                      <div>
                        <h5>Editar Pixel</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="form-group">
                        <input
                          className="form-control"
                          readOnly
                          type="hidden"
                          name="id"
                          value={datosSeleccionados.id}
                          onChange={handleChange}
                        />

                        <label>ID Pixel</label>
                        <textarea
                          className="form-control"
                          name="pixels"
                          value={datosSeleccionados.pixels}
                          onChange={handleChange}
                          rows="4"
                        />
                        <br/>
                        <label>Campaña</label>
                        <select
                          className="form-control"
                          name="campana"
                          value={datosSeleccionados.campana}
                          onChange={handleChange}
                        >
                          <option value="">Seleccione una opción</option>
                          {campanas.map((campana) => (
                     
                            <option key={campana.id_campana} 
                              value={campana.campana}>
                              {campana.campana}
                            </option>
                          ))}
                        </select>
                        <br/>
                        <label>Red</label>
                        <select
                          className="form-control"
                          name="red"
                          value={datosSeleccionados.red}
                          onChange={handleChange}
                        >
                          <option value="">Seleccione una opción</option>
                          <option value="facebook">Facebook</option>
                          <option value="google">Google</option>
                          <option value="tiktok">TikTok</option>
                          <option value="twitter">Twitter</option>
                        </select>
                      
                       
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalEditaruser(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-info"
                        onClick={() => peticionPutuser()}
                      >
                        Actualizar
                      </button>
                    </ModalFooter>
                  </Modal>

                  <Modal isOpen={modalAgregar}>
                    <ModalHeader>
                      <div>
                        <h5>Añadir Pixel</h5>
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="form-group">
                        <label>ID Pixel</label>
                        <textarea
                          className="form-control"
                          name="pixel"
                          value={nuevoPixel.pixel}
                          onChange={handleNuevoPixelChange}
                          rows="2"
                        />
                         <p>(Ejemplo: 123456789)</p>
                        <br />
                        <label>Campaña</label>
                        <select
                          className="form-control"
                          name="campana"
                          value={nuevoPixel.campana}
                          onChange={handleNuevoPixelChange}
                        >
                          <option value="">Seleccione una opción</option>
                          {campanas.map((campana) => (
                            <option key={campana.id_campana} value={campana.campana}>
                              {campana.campana}
                            </option>
                          ))}
                        </select>
                        <br />
                        <label>Red</label>
                        <select
                          className="form-control"
                          name="red"
                          value={nuevoPixel.red}
                          onChange={handleNuevoPixelChange}
                        > 
                         <option value="">Seleccione una opción</option>
                          <option value="facebook">Facebook</option>
                          <option value="google">Google</option>
                          <option value="tiktok">TikTok</option>
                          <option value="twitter">Twitter</option>
                        </select>
                      </div>
                    </ModalBody>
                    <ModalFooter>
                      <button
                        className="btn btn-dark"
                        onClick={() => setModalAgregar(false)}
                      >
                        Cancelar
                      </button>
                      <button
                        className="btn btn-info"
                        onClick={() => peticionPost()}
                      >
                        Añadir
                      </button>
                    </ModalFooter>
                  </Modal>
                </Card.Body>
              </Card>
            </Sidebar>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <Sidebar>
            <SinPermisos />
          </Sidebar>
        </div>
      );
    }
  } else {
    return (
      <div>
        <Sidebar>
          <SinPermisos />
        </Sidebar>
      </div>
    );
  }
};

export default Pixels;